var Utils = {
    months() {
        const months = {
            short: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
            full: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        };
        return months;
    },
    numberToWords() {
        return [ 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten' ];
    },
    formatNumber( num ) {
        num = parseFloat( num );
        num = num ? ( num.toFixed(2).replace('.00', '') ) : 0;
        return num;
    },
    numberWithCommas(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setPlural( txt, num ) {
        let result = 0;
        num    = parseInt( num );
        result = txt + ( ! num || num > 1 ? 's' : '' );
        return result;
    },
    getPercentage( part, whole, formatted = true ) {
        let result = 0;
        part  = parseFloat( part );
        whole = parseFloat( whole );
        result = ( part / whole ) * 100;
        result = formatted ? ( result + '%' ) : result;
        return result;
    },
    formatFullMonthDate( date, monthFormat = 'full' ) {
        let d = new Date( date );
        d = d.getDate() + ' ' + this.months()[monthFormat][ d.getMonth() ] + ' ' + d.getFullYear();
        return d;
    },
    inRange( n, min, max ) {
        return ( ( n - min ) * ( n - max ) <= 0 );
    },
    validateForm( form ) {
        let valid = true;
        $.each( form.find( '.required' ), function(index, item) {
            let val = $.trim( $(this).val() );
            if ( val === '' ) {
                this.focus();
                valid = false;
                if ( $( 'span.error', $(this).parent() ).length == 0 ) {
                    $(this).parent().find( 'label' ).append( '<span class="error">Required</span>' );
                }
                return false;
            } else if ( $(this).attr( 'data-validate' ) == 'email' ) {
                if ( ! (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val)) ) {
                    this.focus();
                    if ( $( '.subscribe .block .text p.alt' ).length ) {
                        const action = form.find( 'input[name="action"]' ).val();
                        if ( 'addMailSubscriber' == action ) {
                            $( '.subscribe .block .text p.alt' ).text( 'Invalid email address.' );
                            $( '.subscribe .block .text' ).removeClass( 'hidden' );
                        }
                    }
                    if ( form.find( '.text.alert' ).length ) {
                        form.find( '.text.alert p' ).text( 'Invalid email address.' );
                        form.find( '.text.alert' ).removeClass( 'hidden' );
                    }
                    if ( form.attr( 'data-subscription-channel' ) == 'prize' ) {
                        Prize.alertMessage = 'Invalid email address.';
                    }
                    valid = false;
                    if ( $( 'span.error', $(this).parent() ).length == 0 ) {
                        $(this).parent().find( 'label' ).append( '<span class="error">Invalid</span>' );
                    } else {
                        $(this).parent().find( 'error' ).text( 'Invalid' );
                    }
                    return false;
                }
            }
        });
        return valid;
    },
    hyphenate(str) {
        return str.replace(/, | &amp; /g, '-');
    },
    formatReviewAuthorNames(str) {
        let splitstr = str.split( ' ' );
        splitstr = this.removeNamePrefixes( splitstr );
        
        splitstr.forEach((word, i) => {
            if ( ! ( word !== word.toUpperCase() ) ) {
               word = word.toLowerCase().replace(/\b\w+/g, function(word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                });
            } 
            splitstr[i] = word;
        });
        return splitstr.join(' ');
    },
    removeNamePrefixes(splitStr) {
        var exceptions = [
            'mr', 'mister', 'ms', 'miss', 'mrs', 'dr', 'prof', 'rev', 'sir', 'lady', 'lord', 'dame', 'capt', 'major', 'col', 
            'gen', 'lt', 'hon', 'rev', 'fr', 'sister', 'brother', 'judge', 'president', 'secretary', 'principal', 'governor'
        ];    
        if ( exceptions.includes( splitStr[0].toLowerCase() ) ) {
            splitStr.shift();
        }    
        return splitStr;
    }
};
